<template>
  <div :id="data.id" class="bg-gray-lighten3 pt-[2.5rem] md:pt-[3.5rem]">
    <div class="container text-slate">
      <UiSectionTitle
        v-if="data.title"
        :title="data.title"
        class="title mb-6 flex whitespace-pre-line text-xl uppercase leading-[1em] md:justify-center md:text-center md:text-[3.5rem]"
      />

      <div v-if="data.items && data.items.length" class="mt-[5rem]">
        <swiper-container ref="swiperEl" init="false" class="apps-swiper pb-11">
          <div
            v-show="isDesktop"
            slot="container-end"
            class="swiper-scrollbar"
          ></div>

          <swiper-slide
            v-for="(item, i) in data.items"
            :key="i"
            class="w-[241px] md:w-[330px]"
          >
            <div
              class="h-[241px] bg-neutral bg-contain bg-center bg-no-repeat md:h-[245px]"
              :style="{ 'background-image': `url(${item.image})` }"
            ></div>

            <div class="min-h-[9px] bg-white p-4 text-sm">
              <div
                v-if="item.name"
                class="title mb-2 uppercase leading-none"
                v-html="item.name"
              />

              <div class="leading-5 text-slate-lighten1" v-html="item.text" />
            </div>
          </swiper-slide>
        </swiper-container>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useBreakpoint, useSwiperElement } from '~/composables';

interface Props {
  data?: any;
}

withDefaults(defineProps<Props>(), {
  data: () => ({}),
});

const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');

const swiperOptions = {
  observer: true,
  slidesPerView: 'auto',
  spaceBetween: 16,
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 180,
    snapOnRelease: true,
  },
};

const swiperEl = useSwiperElement(swiperOptions);
</script>
